import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { debounceTime, filter } from 'rxjs/operators';
import { AnalisisDemandaService } from 'src/app/services/analisis-demanda.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { DocumentoNoTributarioService } from 'src/app/services/documento-no-tributario.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';

@Component({
  selector: 'app-modal-cambio-producto',
  templateUrl: './modal-cambio-producto.component.html',
  styleUrls: ['./modal-cambio-producto.component.scss'],
  providers: [SecurityService],
})
export class AnalisisDemandaModalCambioProductoComponent implements OnInit {
  // Modales
  @ViewChild('cambiarProducto', { static: true }) modalCambioProducto: ModalDirective;
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent;

  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>();

  // Form
  formHeader: FormGroup;

  // Data & tmp
  private rutEmpresa: number;
  private sucursalCodigo: number;
  registro: any = null;
  movimiento: any = null;
  codigoBodega: any = null;
  unidadNegocioCodigo: number = null;
  productoSeleccionado: any = null;
  optionsFormato: Array<any> = [];

  // Utils
  private log: any;

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private analisisDemandaService: AnalisisDemandaService,
    private messageRendererService: MessageRendererService,
    private documentoNoTributarioService: DocumentoNoTributarioService,
    private formatoProductoService: FormatoProductosService
  ) {
    this.log = this.clog.log('ANALISIS-DEMANDA-CAMBIO-PRODUCTO');
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());

    this.createForm();
    this.formChangesSubscriptions();
  }

  private createForm() {
    this.formHeader = this.fb.group({
      sku: [null, [Validators.required]],
      formato: [null, [Validators.required]],
    });
  }

  private formChangesSubscriptions() {
    this.formHeader
      .get('sku')
      .valueChanges.pipe(filter(Boolean), debounceTime(500))
      .subscribe((codigo: string) => {
        this.modalSeleccionarProducto.searchBySKU(codigo);
      });
  }

  public loadAndShow(movimiento, codigoBodega, unidadNegocioCodigo: number = null) {
    this.cleanupProductoData();
    this.movimiento = movimiento;
    this.codigoBodega = codigoBodega;
    this.unidadNegocioCodigo = unidadNegocioCodigo;
    const { detalleAnalisisDemanda } = this.movimiento;
    this.modalCambioProducto.show();

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      productoCodigo: detalleAnalisisDemanda[0].producto_codigo,
      formatoCodigo: detalleAnalisisDemanda[0].producto_formato,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.analisisDemandaService.ObtenerCantidadEnQuiebre(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null;
      if (!ok) {
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.registro = respuesta;
    });
  }

  private cleanupProductoData() {
    this.productoSeleccionado = null;
    this.optionsFormato = [];
    this.formHeader.get('sku').setValue(null);
    this.formHeader.get('formato').setValue(null);
  }

  openModalSeleccionarProducto() {
    this.modalSeleccionarProducto.showWithConfig({
      defaultUnidadNegocio: this.unidadNegocioCodigo,
      showUnidadDeNegocioIfAllowed: false,
    });
  }

  handleRemoteQuery({ inputParams, callback }) {
    this.modalSeleccionarProducto.getProductsByUnidadNegocio({
      inputParams: { ...inputParams, unidad_negocio_codigo: this.unidadNegocioCodigo },
      callback,
    });
  }

  onProductoSeleccionado({ data: _productoSeleccionado }) {
    this.productoSeleccionado = _productoSeleccionado;
    this.formHeader.get('sku').setValue(_productoSeleccionado.sku);

    this.formatoProductoService.GetFormatosByCodigo(this.rutEmpresa, this.productoSeleccionado.codigo, ({ mensajes, respuesta }) => {
      this.log('callback', respuesta.registros);
      this.optionsFormato = respuesta.registros.map((formato) => ({ value: formato.formato_codigo, label: formato.formato_nombre, precio_costo: formato.precio_costo, ...formato }));
      this.formValidatorsService.selectDefaultFormatoProducto(this.formHeader.get('formato'), this.optionsFormato);
    });
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null;
    this.optionsFormato = [];
    this.formHeader.get('formato').setValue(null);
  }

  Cambiar() {
    if (!this.productoSeleccionado) {
      this.toastService.error('Seleccione producto');
      return;
    }

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      productoCodigoOrigen: this.movimiento.detalleAnalisisDemanda[0].producto_codigo,
      formatoCodigoOrigen: this.movimiento.detalleAnalisisDemanda[0].producto_formato,
      productoCodigoDestino: this.productoSeleccionado.codigo,
      formatoCodigoDestino: this.formHeader.get('formato').value,
      codigoBodega: this.codigoBodega,
    };

    this.log('inputParams', JSON.stringify(inputParams));

    this.documentoNoTributarioService.CambiaProducto(inputParams, ({ mensajes, respuesta }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showInfoMessages(mensajes);
        this.messageRendererService.showErrors(mensajes);
        return;
      }
      this.toastService.success('Operación exitosa');
      this.modalCambioProducto.hide();
      this.onSuccess.emit();
    });
  }
}
